import { atom } from "jotai";
import { zslAtom } from "./zslAtom";

export const templateSlugAtom = atom<string | undefined>((get) => {
  const template = get(zslAtom);
  return template?.slug;
});

templateSlugAtom.debugLabel = "templateSlugAtom";
